import { apiFetch } from '@/shared/api/client'

export type AttendanceAction = 'check_in' | 'check_out'

export type WarehouseAttendanceStaff = {
  id: string
  name: string
  role: string
  role_label: string
  shift_start: string
  shift_end: string
  check_in_at?: string
  check_out_at?: string
  check_in_photo?: string
  check_out_photo?: string
  on_time?: boolean
}

type TodayAttendanceResponse = {
  staff: WarehouseAttendanceStaff[]
}

export type AttendanceSubmitResponse = {
  recorded_at: string
  on_time: boolean
  authority?: 'full' | 'attendance_only'
  head_present?: boolean
}

type UploadPhotoResponse = {
  key: string
  url: string
}

export async function fetchTodayAttendance(): Promise<WarehouseAttendanceStaff[]> {
  const res = await apiFetch<TodayAttendanceResponse>('/warehouse/attendance/today')
  return res.staff ?? []
}

export function uploadAttendancePhoto(file: File, clientEventId: string): Promise<UploadPhotoResponse> {
  const body = new FormData()
  body.append('file', file)
  body.append('purpose', 'attendance_selfie')
  body.append('client_event_id', clientEventId)
  return apiFetch<UploadPhotoResponse>('/uploads', { method: 'POST', body })
}

export function submitAttendance(
  action: AttendanceAction,
  payload: { userId: string; pin: string; photoUrl: string },
): Promise<AttendanceSubmitResponse> {
  return apiFetch<AttendanceSubmitResponse>(`/warehouse/attendance/${action === 'check_in' ? 'check-in' : 'check-out'}`, {
    method: 'POST',
    body: JSON.stringify({
      user_id: payload.userId,
      pin: payload.pin,
      photo_url: payload.photoUrl,
    }),
  })
}
